// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"cd028b1e","641":"90818c7a"}[chunkId] + ".chunk.js";
};